<template>
<div class="weekly">
    <div class="run-every-week">
        <div class="week-title">{{$t('language.popup.everyWeek')}}</div>
        <div class="every-week" :class="shakeBox">
            <div @mouseenter="hoverCurrent=index" @mouseleave="hoverCurrent=-1" v-for="(item, index) in weekData" :key="index" @click="checkWeekDay(index)" :class="[weekArr.includes(index+1)&&!disable?'click-weekday':'',weekArr.includes(index+1)&&disable?'click-weekday-disable':'',hoverCurrent==index&&!weeklyDisable?'every-weekday-hover':'',weeklyDisable?'every-weekday-disable':'every-weekday']">
                {{item.name}}
            </div>
        </div>
    </div>
    <div class="every-weektime">
        <div class="weektime-title">{{$t('language.popup.at')}}</div>
        <time-selector ref="weekTime" :disable='weekArr.length==0||weeklyDisable' @changeTime="onchangeWeeklyTime" style="margin-left:10px"></time-selector>
    </div>
</div>
</template>

<script>
import timeSelector from "@/components/common/selector/time_selector";
export default {
    props: ['disable'],
    components: {
        "time-selector": timeSelector
    },
    data: function () {
        return {
            weekData: [{
                name: this.$t('language.popup.sunday')
            }, {
                name: this.$t('language.popup.monday')
            }, {
                name: this.$t('language.popup.tuesday')
            }, {
                name: this.$t('language.popup.wednesday')
            }, {
                name: this.$t('language.popup.thursday')
            }, {
                name: this.$t('language.popup.friday')
            }, {
                name: this.$t('language.popup.saturday')
            }],
            weekArr: [],
            hoverCurrent: -1,
            times: '',
            weeklyDisable: false,
            shakeBox: ''
        }
    },
    methods: {
        onchangeWeeklyTime(value) {
            this.times = value;
            if (this.weekArr.length) {
                this.$parent.$parent.$parent.times = [];
                this.$parent.$parent.$parent.times.push(this.times);
                this.$parent.$parent.$parent.oldWeekTimes = [];
            }
        },
        checkWeekDay(index) {
            if (this.weekArr.includes(index+1)) {
                this.weekArr = this.weekArr.filter(
                    function (ele) {
                        return ele != index+1;
                    });
            } else {
                this.$parent.$parent.$parent.date = '';
                this.$parent.$parent.$parent.days = [];
                this.$parent.$parent.$parent.schedules.type = 'Weekly';
                var value = parseInt(index)+1;
                this.weekArr.push(value);
            }
            this.$parent.$parent.$parent.times = [];
            this.$parent.$parent.$parent.times.push(this.times);
            this.$parent.$parent.$parent.weeks = Object.assign([], this.weekArr);
            this.clearOtherTabData();
        },
        clearOtherTabData() {
            this.$parent.$parent.$parent.$refs.daily.checkArr = [];
            this.$parent.$parent.$parent.$refs.daily.dailyTimeArr = [];
            this.$parent.$parent.$parent.$refs.daily.dailyDisableFlage = true;
            this.$parent.$parent.$parent.$refs.daily.onceDisableFlage = true;
            this.$parent.$parent.$parent.$refs.monthly.monthArr = [];
        }
    },
}
</script>

<style>
.weekly {
    height: 150px;
    /*no*/
    position: absolute;
    left: 0;
    right: 0;
    margin: auto;
}

.run-every-week {
    width: 100%;
    height: 75px;
    /*no*/
    margin-bottom: 40px;
    /*no*/
}

.week-title {
    height: 100%;
    float: left;
    line-height: 30px;
    /*no*/
}

.every-week {
    width: 400px;
    /*no*/
    height: 100%;
    float: left;
}

.every-weekday {
    border: 1px solid #cdddf5;
    /*no*/
    width: 90px;
    /*no*/
    height: 30px;
    /*no*/
    margin: 0px 0px 10px 5px;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
}

.every-weekday-disable {
    border: 1px solid #d2d4d8;
    /*no*/
    width: 90px;
    /*no*/
    height: 30px;
    /*no*/
    margin: 0px 0px 10px 5px;
    /*no*/
    text-align: center;
    line-height: 30px;
    /*no*/
    font-size: 14px;
    /*no*/
    float: left;
    color: #d2d4d8;
    pointer-events: none;
}

.every-weektime {
    width: 100%;
    height: 32px;
    /*no*/
    box-sizing: border-box;
    padding-left: 80px;
    /*no*/
}

.weektime-title {
    height: 100%;
    float: left;
    line-height: 30px;
    /*no*/
}

.every-weekday-hover {
    border: 1px solid #81ABFF;
    /*no*/
    background: #EEF0FF;
}

.click-weekday {
    border: none;
    background: #7987E2;
    color: #fff;
    border: 1px solid #7987E2;
    /*no*/
}

.click-weekday-disable {
    border: none;
    background: #c8d1f7;
    color: #fff;
    border: 1px solid #c8d1f7;
    /*no*/
}
</style>



// WEBPACK FOOTER //
// src/components/common/tabs/tabs_transfer_schedule/tab_weekly.vue